/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Text } from '#UNSAFE_Text';
import { Property } from 'csstype';
import { classNames } from '#utils/UNSAFE_classNames';
import { styles } from '#PRIVATE_BaseLegend/themes/LegendStyles.css';

type LegendTextProps = {
  text: string;
  type: 'label' | 'title';
  fontStyle?: Property.FontStyle;
  fontSize?: Property.FontSize;
  fontWeight?: Property.FontWeight;
  textDecoration?: Property.TextDecoration;
  color?: Property.Color;
  fontFamily?: Property.FontFamily;
  id?: string;
  align?: 'start' | 'center' | 'end';
};

/**
 * Returns the legend text component.
 */
export const LegendText = ({
  text,
  type = 'label',
  id,
  align = 'start',
  ...props
}: LegendTextProps) => {
  const {
    legendTextBaseStyle,
    legendTextTitle,
    legendTitleStartAlign,
    legendTitleCenterAlign,
    legendTitleEndAlign
  } = styles;
  const isTitle = type === 'title';
  return (
    <div
      class={classNames([
        legendTextBaseStyle,
        isTitle ? legendTextTitle : '',
        isTitle && align === 'start' ? legendTitleStartAlign : '',
        isTitle && align === 'center' ? legendTitleCenterAlign : '',
        isTitle && align === 'end' ? legendTitleEndAlign : ''
      ])}
      style={{
        ...props
      }}>
      <Text size="inherit" variant="inherit" weight="inherit" truncation={'ellipsis'} id={id}>
        {text}
      </Text>
    </div>
  );
};
